import { inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { isBrowser } from '../utils/platform.util';

/**
 * Functional guard to protect routes requiring authentication.
 * Redirects to /login if the user is not authenticated.
 */
export const authGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isBrowser(platformId)) {
    return true;
  }

  if (authService.isAuthenticated()) {
    // 1. Force Change Password if required
    // Skip if already on change-password route to avoid infinite loop
    if (authService.mustChangePassword() && route.routeConfig?.path !== 'change-password') {
      return router.createUrlTree(['/change-password']);
    }
    return true;
  }

  // Fallback: Check if we have a valid token but signal hasn't updated (edge case)
  // But initializeAuth should have handled it.
  
  return router.createUrlTree(['/login']);
};
